import { namespace as createVuexClass } from 'vuex-class';
import { InlineResponse200 } from 'ctp-history-service';

export const namespace = 'history';
export const store = createVuexClass(namespace);

export const FETCH_HISTORY = 'fetchHistory';
export const FETCH_FILTERS_META = 'fetchFiltersMeta';
export const FETCH_FILTERS = 'fetchFilters';
export const HISTORY_NAVIGATION = 'historyNavigation';
export const UPDATE_NAVIGATION = 'updateNavigation';
export const UPDATE_HISTORY_STATE = 'updateHistoryState';

export const SET_FILTER_CATEGORIES = 'setFilterCategories';
export const CLEAR_FILTERS = 'clearFilters';

export const SET_ERROR = 'setError';
export const REINIT = 'reinit';

export interface HistoryCategory {
  name: string;
  subCategories: string[];
}

export interface HistoryType {
  categories: HistoryCategory[];
  name: string;
}

export interface IOperationState {
  [view: string]: boolean;
}

export interface IHistoryStatePayload {
  stateKey: string;
  view: string;
  stateValue: boolean;
}

export interface IHistoryState {
  [state: string]: IOperationState;
}

export interface INavigation {
  start: number;
  size: number;
  direction: 'backward' | 'forward';
  isLastHistoryPage: boolean;
}

export interface HistoryFilterPayload {
  start?: number;
  size: number;
  deviceId?: string;
  identifierMatchers?: string[];
  dtcoIds?: string[];
  plateNumber?: string;
  from?: number;
  to?: number;
  historyType?: string;
  subCategory?: string[];
  highPriority?: boolean;
}

export interface HistoryState {
  historyState: IHistoryState;
  history: InlineResponse200;
  filters: HistoryType[];
  selectedFilters: HistoryFilterPayload;
  selectedFilterCategories: string[];
  navigation: INavigation;
  errorMessage: string;
}
